/* eslint no-unused-vars:0 */
import _ from 'lodash'
import React, { Component } from 'react'
import { Col, FormGroup, Panel } from "react-bootstrap";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm, propTypes, formValueSelector, change } from 'redux-form'
import { PropTypes } from 'prop-types'
import moment from 'moment'
import ModalWindow from '../../../../utils/modalwindow'
import ModalTable from '../../../../utils/modaltable'
import normalizePhone from '../../../../utils/normalizePhone'
import {
  forms, countries, states, canadianprovinces, gray, videoblue, orange, green, blue,
  lblattrs, inputattrxsmall, lblattrsWide, inputattrs, inputattrsSmall
} from '../../../../utils/constants'
import isEmpty from '../../../../utils/isEmpty'
import {
  fetchMember,
  fetchEvent,
  fetchCenter,
  fetchActiveSeasons,
  saveEventInfo,
  resendEventEmail,
  resendingEventEmail,
  setCorrectEventInfo
} from "../../../../redux/actions/action_event"
import { SEARCH_BY_NAME } from "../../../../redux/actions"
import { renderField } from '../../../../modules/components/fieldcomponent'
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent'
import { renderDatePickerField } from '../../../../modules/components/datepickercomponent'
import { renderSelectField } from '../../../../modules/components/selectfieldcomponent'
import { renderInputWithSearchField } from '../../../../modules/components/inputwithsearchfieldcomponent'
import CorrectEventInfo from "../CorrectEventInfo"
import EventInfoFields from './fields'
import 'react-datepicker/dist/react-datepicker.css'
import '../../../../utils/css/nospinner.css'

const FormName = forms.eventinfo

const readOnly = {
  fontWeight: 'bold', minWidth: '100px', textAlign: 'left'
}

class EventInfo extends Component {

  static propTypes = {
    ...propTypes
  }
  constructor(props, context) {
    super(props, context)
    this.onHandleGetCenterInfo = this.onHandleGetCenterInfo.bind(this)
    this.onHandleGetCenterInfoByNumber = this.onHandleGetCenterInfoByNumber.bind(this)
    this.handleGetMemberInfo = this.handleGetMemberInfo.bind(this)
    this.handleValidInfo = this.handleValidInfo.bind(this)
    this.handleResetEventLocation = this.handleResetEventLocation.bind(this)
    this.handleResetEventDirector = this.handleResetEventDirector.bind(this)
    this.setSeasons = this.setSeasons.bind(this)
    this.isInfoEqual = this.isInfoEqual.bind(this)
    this.handleSeasonChange = this.handleSeasonChange.bind(this)
    this.handleResendEmail = this.handleResendEmail.bind(this)
  }
  //#region Component lifecycle events
  componentWillUnmount() {
    const { dispatch } = this.props
    const { isInfoEqual } = this
    const {
      saveEventInfo, eventname, eventaddress, eventcity, eventzipcode, eventstate, eventcountry, season, startdate, enddate, centername,
      centercertnumber, memberidsuffix, memberidprefix, directorname, directorssoemail, eventemail, directorphone, directorcountry,
      directoraddress1, directoraddress2, directorcity, directorstate, directorzipcode, eventId, info, prestineinfo
    } = this.props
    
    const saveInfo = !isInfoEqual(prestineinfo, this.props)
    // if information has not changed then there is no need to save it
    if (saveInfo) {
      const centerAddress = {
        addressLine1: eventaddress,
        city: eventcity,
        state: eventstate,
        zipcode: eventzipcode,
        country: eventcountry
      }
      const directorAddress = {
        addressLine1: directoraddress1,
        addressLine2: directoraddress2,
        city: directorcity,
        state: directorstate,
        zipcode: directorzipcode,
        country: directorcountry
      }
      const info = {
        eventId: eventId,
        seasonId: season,
        step: 1,
        name: eventname,
        startDate: startdate,
        endDate: enddate,
        centerCertificationNumber: centercertnumber,
        centerName: centername,
        centerAddress,
        directorName: directorname,
        directorPhoneNumber: directorphone,
        directorUsbcMemberId: `${memberidprefix}-${memberidsuffix}`,
        directorSSOEmail: directorssoemail,
        eventEmail: eventemail,
        directorAddress
      }
      dispatch(change(FormName, 'savingdata', true))
      saveEventInfo(info)
    }
  }

  UNSAFE_componentWillUpdate() {
    const { resendingemail, searchMode, dispatch } = this.props
    if (searchMode === true) {
      dispatch(change(FormName, 'searchMode', false))
    }
  }
  //#endregion component lifecycle events
  handleResendEmail(e) {
    e.preventDefault()
    const { dispatch, eventId } = this.props
    const event = {
      eventId
    }
    dispatch(resendingEventEmail())
    dispatch(resendEventEmail(event))
  }
  handleValidInfo(isValid) {
    const { dispatch, eventId } = this.props
    dispatch(setCorrectEventInfo(eventId, isValid, 'none'))
  }
  handleResetEventLocation(event) {
    const fieldname = event.target.name
    const { dispatch, centercertnumber, centername, eventaddress, eventcity, eventstate, eventzipcode } = this.props

    if (!isEmpty(centercertnumber) && fieldname !== EventInfoFields.CENTER_CERTNUMBER) {
      dispatch(change(FormName, EventInfoFields.CENTER_CERTNUMBER, ''))
    }
    if (!isEmpty(centername) && fieldname != EventInfoFields.CENTER_NAME) {
      dispatch(change(FormName, EventInfoFields.CENTER_NAME, ''))
    }
    if (!isEmpty(eventaddress)) {
      dispatch(change(FormName, EventInfoFields.EVENT_ADDRESS, ''))
    }
    if (!isEmpty(eventcity)) {
      dispatch(change(FormName, EventInfoFields.EVENT_CITY, ''))
    }
    if (!isEmpty(eventstate)) {
      dispatch(change(FormName, EventInfoFields.EVENT_STATE, ''))
    }
    if (!isEmpty(eventzipcode)) {
      dispatch(change(FormName, EventInfoFields.EVENT_ZIPCODE, ''))
    }
  }
  handleResetEventDirector() {
    const { dispatch, directorname, directorssoemail, eventemail, directorphone, directorcountry, directoraddress1,
      directoraddress2, directorcity, directorstate, directorzipcode
    } = this.props

    if (!isEmpty(directorname)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_NAME, ''))
    }
    if (!isEmpty(directorssoemail)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_SSOEMAIL, ''))
    }
    if (!isEmpty(eventemail)) {
      dispatch(change(FormName, EventInfoFields.EVENT_EMAIL, ''))
    }
    if (!isEmpty(directorphone)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_PHONE, ''))
    }
    if (!isEmpty(directorcountry)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_COUNTRY, ''))
    }
    if (!isEmpty(directoraddress1)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_ADDRESS1, ''))
    }
    if (!isEmpty(directoraddress2)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_ADDRESS2, ''))
    }
    if (!isEmpty(directorcity)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_CITY, ''))
    }
    if (!isEmpty(directorstate)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_STATE, ''))
    }
    if (!isEmpty(directorzipcode)) {
      dispatch(change(FormName, EventInfoFields.DIRECTOR_ZIPCODE, ''))
    }
  }
  onHandleGetCenterInfo(event) {
    event.preventDefault()

    this.props.dispatch(change(FormName, 'searchMode', true))
    const searchvalue = this.props.centername
    this.props.fetchCenter(SEARCH_BY_NAME, searchvalue)
  }
  onHandleGetCenterInfoByNumber(event) {
    event.preventDefault()
    const searchvalue = this.props.centercertnumber
    const searchby = 'searchbynumber'
    this.props.fetchCenter(searchby, searchvalue)
  }
  handleGetMemberInfo(event) {
    const { dispatch, memberidprefix, memberidsuffix, oidc } = this.props
    event.preventDefault()
    dispatch(change(FormName, 'searchMode', true))
    const token = oidc.user.access_token
    //console.log('handleGetMemberInfo token', token)
    dispatch(fetchMember(memberidprefix, memberidsuffix, token))
  }
  handleSeasonChange(event) {
    const { seasons, dispatch } = this.props
    if (seasons) {
      const selectedSeason = parseInt(event.target.value)
      const eventSeasonSettings = _.find(seasons, { 'id': selectedSeason })
      if (eventSeasonSettings) {
        dispatch(change(FormName, 'eventSeasonSettings', eventSeasonSettings))
      }
    }
  }
  handleChange(e) {
    const re = /^[0-9\b]+$/;
    const value = e.target.value
    const id = e.target.id

    if ((e.target.value == '' || re.test(e.target.value)) && (value.length < 4)) {
      this.setState({ [id]: value })
    }
  }
  isInfoEqual(original, current) {
    let equal = true
    
    if ((original != undefined) && (current != undefined)) {
      if (original.eventname != current.eventname) {
        equal = false
      }
      if (original.startdate != current.startdate) {
        equal = false
      }
      if (original.enddate != current.enddate) {
        equal = false
      }
      if (original.centername != current.centername) {
        equal = false
      }
      if (original.centercertnumber != current.centercertnumber) {
        equal = false
      }
      if (original.memberidsuffix != current.memberidsuffix) {
        equal = false
      }
      if (original.memberidprefix != current.memberidprefix) {
        equal = false
      }
      if (original.eventemail != current.eventemail) {
        equal = false
      }
      if (original.directorssoemail != current.directorssoemail) {
        equal = false
      }
      if (original.directorphone != current.directorphone) {
        equal = false
      }
      if (original.eventemail != current.eventemail) {
        equal = false
      }
    }
    else {
      equal = false
    }

    return equal

  }
  setSeasons() {
    const { seasons, dispatch } = this.props
    const activeseasons = []
    seasons.map(function (season) {
      activeseasons.push({
        name: season.description,
        abbreviation: season.id.toString(),
        isCurrent: season.isCurrent
      })
    })
    return activeseasons
  }

  render() {

    const {
      handleSubmit, eventcountry, isEventInfoVerified, eventVerificationEmailSent, season, centername, centercertnumber,
      searchMode, norecordsfound, dispatch, centers, memberidsuffix, memberidprefix, directorcountry, eventname, startdate, enddate,
      savingData, resendingemail, user, eventId, oidc
    } = this.props

    const { isAdministrator } = user
    const multiplecenters = (centers !== null) && (centers !== undefined) && (centers.Results.length > 1)
    const imageIcon = savingData ? 'fa fa-spinner fa-spin' : "fa fa-caret-right"
    const resendingIcon = resendingemail ? 'fa fa-spinner fa-spin' : "fa fa-envelope"
    const countrystates = directorcountry === 'US' ? states : canadianprovinces

    const disabled = !isAdministrator
    let formmattedStartDate = ''
    let formmattedEndDate = ''
    //const token = ((oidc != null) && (oidc != undefined)) ? oidc.user.access_token:''
    if (!isAdministrator) {
      formmattedStartDate = moment(startdate).format('LLLL')
      formmattedEndDate = moment(enddate).format('LLLL')
    }
    const activeSeasons = this.setSeasons()

    return (
      <div style={{ marginTop: '1%' }}>
        {
          // client searched and no records were found
          norecordsfound &&
          (<ModalWindow
            title='No records found'
            message='We could not find any records matching the search criteria specified.'
            trigger='norecordsfound'
            dispatch={dispatch} />)
        }
        {
          // client search and multiple records were returned
          multiplecenters && (<ModalTable
            title='Multiple records found'
            records={centers}
            dispatch={dispatch} />)
        }
        <form id='eventinfo' onSubmit={handleSubmit} className="form-horizontal"
          sm={12} style={{ padding: '0', margin: '0' }}  >

          {
            isAdministrator &&
            (
              <Col md={12} lg={6} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px' }} >
                <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                  <h4 className='text-left' style={{ color: videoblue }}>{' '}Event Dates and Location</h4>
                </FormGroup>
                <Field
                  type='text'
                  text='1'
                  name="wizardstep"
                  component="input"
                  className="hidden"
                />
                <Field
                  label='Season'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.SEASON}
                  id={EventInfoFields.SEASON}
                  values={activeSeasons}
                  component={renderOptionsField}
                  defaultvalue={season}
                  onChange={this.handleSeasonChange}
                  disabled={disabled}
                />

                <Field
                  label='Event Name'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.NAME}
                  component={renderField}
                  placeholder='Type event name'
                />
                <Field
                  label='Start Date'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  title='Event start date'
                  name={EventInfoFields.STARTDATE}
                  component={renderDatePickerField}
                  placeholder='mm-dd-yyyy'
                />
                <Field
                  label='End Date'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.ENDDATE}
                  title='Event end date'
                  component={renderDatePickerField}
                  placeholder='mm-dd-yyyy'
                />
                <Field
                  label='Center Cert. #'
                  labelattrs={lblattrs}
                  inputattrs={inputattrsSmall}
                  name={EventInfoFields.CENTER_CERTNUMBER}
                  buttonid={EventInfoFields.CENTER_CERTNUMBER + '-search'}
                  type='number'
                  buttondisabled={isEmpty(centercertnumber) || searchMode}
                  placeholder='Type center certificaction number'
                  component={renderInputWithSearchField}
                  onsearch={this.onHandleGetCenterInfoByNumber}
                  loading={searchMode}
                  onChange={this.handleResetEventLocation}
                  className='no-spinners'
                />
                <Field
                  label='Center Name'
                  labelattrs={lblattrs}
                  inputattrs={inputattrsSmall}
                  name={EventInfoFields.CENTER_NAME}
                  buttonid={EventInfoFields.CENTER_NAME + '-search'}
                  buttondisabled={isEmpty(centername) || (centername.length < 3) || searchMode}
                  placeholder='Type center name (min 3 characters long)'
                  component={renderInputWithSearchField}
                  onsearch={this.onHandleGetCenterInfo}
                  loading={searchMode}
                  onChange={this.handleResetEventLocation}
                />
                <Field
                  label='Country'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.EVENT_COUNTRY}
                  id={EventInfoFields.EVENT_COUNTRY}
                  component={renderOptionsField}
                  values={countries}
                  defaultvalue={eventcountry}
                />
                <Field
                  label='Address'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.EVENT_ADDRESS}
                  component={renderField}
                  disabled='disabled'
                />
                <Field
                  label='City'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.EVENT_CITY}
                  component={renderField}
                  disabled='disabled'
                />
                {eventcountry == 'US' && (<Field
                  label='State'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.EVENT_STATE}
                  component={renderSelectField}
                  values={states}
                  disabled
                />)}
                {eventcountry == 'CA' && (<Field
                  label='Province'
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.EVENT_STATE}
                  component={renderSelectField}
                  values={canadianprovinces}
                />)}
                <Field
                  label={eventcountry == 'usa' ? 'Zip Code' : 'Postal Code'}
                  labelattrs={lblattrs}
                  inputattrs={inputattrs}
                  name={EventInfoFields.EVENT_ZIPCODE}
                  component={renderField}
                  disabled='disabled'
                />
                <FormGroup style={{ height: '47px', padding: '0', margin: '0' }}>
                  <span>{' '}</span>
                </FormGroup>
              </Col>
            )
          }
          {
            isAdministrator &&
            (<Col md={12} lg={6} style={{ border: `1px solid ${gray}`, borderLeftWidth: '0', padding: '15px' }}>
              <FormGroup style={{ padding: '0 0 15px 25px', margin: '0' }}>
                <h4 className='text-left' style={{ color: videoblue }}>{' '}Director Information</h4>
              </FormGroup>
              <FormGroup>
                <label className={lblattrsWide}>USBC Member ID</label>
                <Col sm={3} md={3} lg={3}>
                  <Field
                    className="form-control no-spinners"
                    placeholder='Prefix (#)'
                    component="input"
                    type='number'
                    name={EventInfoFields.MEMBERID_PREFIX}
                    onChange={this.handleResetEventDirector}
                  />
                </Col>
                <Col sm={3} md={3} lg={4} style={{ marginLeft: '-28px', minWidth: '130px' }}>
                  <Field
                    className="form-control no-spinners"
                    placeholder='Suffix (#)'
                    component="input"
                    type='number'
                    name={EventInfoFields.MEMBERID_SUFFIX}
                    onChange={this.handleResetEventDirector}
                  />
                </Col>
                <Col sm={1} lg={1} md={1}>
                  <span className="input-group-btn" sm={1} md={1} lg={1}>
                    <button
                      type="button"
                      className="btn btn-default"
                      id='button'
                      style={
                        {
                          marginLeft: '-32px', marginTop: '-1px', minHeight: '37px', maxWidth: '41px',
                          borderRadius: '0', color: orange
                        }
                      }
                      onClick={this.handleGetMemberInfo}
                      disabled={isEmpty(memberidprefix) || isEmpty(memberidsuffix)}>

                      <i className={searchMode === true ? "fa fa-spinner fa-spin" : "fa fa-search"} aria-hidden="true" />
                    </button>
                  </span>
                </Col>
              </FormGroup>
              <Field
                label='Name'
                name={EventInfoFields.DIRECTOR_NAME}
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                component={renderField}
                disabled='disabled'
              />
              <Field
                label='Email'
                name={EventInfoFields.DIRECTOR_SSOEMAIL}
                type='email'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                component={renderField}
                disabled='disabled'
              />
              <Field
                label='Event Email'
                name={EventInfoFields.EVENT_EMAIL}
                type='email'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                component={renderField}
              />
              <Field
                label='Phone Number'
                labelattrs={lblattrsWide}
                inputattrs={inputattrxsmall}
                name={EventInfoFields.DIRECTOR_PHONE}
                component={renderField}
                normalize={normalizePhone}

              />
              <Field
                label='Country'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                name={EventInfoFields.DIRECTOR_COUNTRY}
                id={EventInfoFields.DIRECTOR_COUNTRY}
                component={renderOptionsField}
                values={countries}
                defaultvalue={directorcountry}
              />
              <Field
                label='Address Line 1'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                name={EventInfoFields.DIRECTOR_ADDRESS1}
                component={renderField}
              />
              <Field
                label='Address Line 2'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                name={EventInfoFields.DIRECTOR_ADDRESS2}
                component={renderField}
              />
              <Field
                label='City'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                name={EventInfoFields.DIRECTOR_CITY}
                component={renderField}
              />
              <Field
                label='State'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                name={EventInfoFields.DIRECTOR_STATE}
                component={renderSelectField}
                values={countrystates}
              />
              <Field
                label='Zip Code'
                labelattrs={lblattrsWide}
                inputattrs={inputattrsSmall}
                name={EventInfoFields.DIRECTOR_ZIPCODE}
                component={renderField}
              />
              <FormGroup style={{ height: '40px', padding: '0', margin: '0' }}>
                <button className="btn btn-default pull-right" style={{ minWidth: '80px', fontSize: '120%', color: blue, borderWidth: '2px', fontWeight: 'bold' }}
                  onClick={this.handleResendEmail} disabled={!eventVerificationEmailSent}>
                  <i className={resendingIcon} aria-hidden="true" />&nbsp;{' '}Resend email
                </button>
              </FormGroup>
            </Col>
            )
          }
          {

            !isAdministrator && (
              <Panel>
                <Col md={12} lg={6} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px', fontSize: '120%' }}>
                  <h4 style={{ color: videoblue }}> Event Dates and Location </h4>
                  <label style={readOnly}>Season Year:</label>&nbsp;&nbsp;{activeSeasons.name}
                  <br />
                  <label style={readOnly}>Event Name:</label>&nbsp;&nbsp;{eventname}
                  <br />
                  <label style={readOnly}>Start Date:</label>&nbsp;&nbsp;{formmattedStartDate.substring(0, formmattedStartDate.length - 8)}
                  <br />
                  <label style={readOnly}>End Date:</label>&nbsp;&nbsp;{formmattedEndDate.substring(0, formmattedEndDate.length - 8)}
                  <br />
                  <label style={readOnly}>Center Cert #:</label>&nbsp;&nbsp;{centercertnumber}
                  <br />
                  <label style={readOnly}>Center Name:</label>&nbsp;&nbsp;{centername}
                  <br />
                  <label style={readOnly}>Address:</label>&nbsp;&nbsp;{this.props.eventaddress}
                  <br />
                  <label style={readOnly}>City:</label>&nbsp;&nbsp;{this.props.eventcity}
                  <br />
                  <label style={readOnly}>State:</label>&nbsp;&nbsp;{this.props.eventstate}
                  <br />
                  <label style={readOnly}>ZipCode:</label>&nbsp;&nbsp;{this.props.eventzipcode}
                  <br />
                  <label style={readOnly}>Country:</label>&nbsp;&nbsp;{this.props.eventcountry}
                </Col>
                <Col md={12} lg={6} style={{ border: `1px solid ${gray}`, padding: '15px', marginRight: '0px', marginBottom: '15px', fontSize: '120%' }}>
                  <h4 style={{ color: videoblue }}>Director Information </h4>
                  <label style={readOnly}>USBC Member ID:</label>&nbsp;&nbsp;{memberidprefix}&nbsp;-&nbsp;{memberidsuffix}
                  <br />
                  <label style={readOnly}>Name:</label>&nbsp;&nbsp;{this.props.directorname}
                  <br />
                  <label style={readOnly}>Email:</label>&nbsp;&nbsp;{this.props.directorssoemail}
                  <br />
                  <label style={readOnly}>Event Email:</label>&nbsp;&nbsp;{this.props.eventemail}
                  <br />
                  <label style={readOnly}>Phone Number:</label>&nbsp;&nbsp;{this.props.directorphone}
                  <br />
                  <label style={readOnly}>Country:</label>&nbsp;&nbsp;{this.props.directorcountry}
                  <br />
                  <label style={readOnly}>Address Line 1:</label>&nbsp;&nbsp;{this.props.directoraddress1}
                  <br />
                  <label style={readOnly}>Address Line 2:</label>&nbsp;&nbsp;{this.props.directoraddress2}
                  <br />
                  <label style={readOnly}>City:</label>&nbsp;&nbsp;{this.props.directorcity}
                  <br />
                  <label style={readOnly}>State:</label>&nbsp;&nbsp;{this.props.directorstate}
                  <br />
                  <label style={readOnly}>Zip Code:</label>&nbsp;&nbsp;{this.props.directorzipcode}

                </Col>
              </Panel>)

          }
          <Col sm={12} style={{ marginTop: '10px' }} >
            {
              !isAdministrator && !isEventInfoVerified && <CorrectEventInfo onInfoIsCorrect={this.handleValidInfo} eventId={eventId} />
            }
          </Col>
          <Col sm={12} >
            <button type="submit" className="btn btn-primary pull-right next" style={{ minWidth: '120px', fontSize: '120%', fontWeight: 'bold' }}>
              <i className={imageIcon} aria-hidden="true" />&nbsp;&nbsp; Next
            </button>
          </Col>

        </form>
      </div>)
  }
}
EventInfo.propTypes = {
  handleSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  fetchEvent: PropTypes.func,
  fetchMember: PropTypes.func,
  fetchActiveSeasons: PropTypes.func,
  saveEventInfo: PropTypes.func,
  resendEventEmail: PropTypes.func,
  resendingEventEmail: PropTypes.func,
  anyTouched: PropTypes.bool,
  eventId: PropTypes.number,
  eventname: PropTypes.string,
  centercertnumber: PropTypes.number,
  centername: PropTypes.string,
  startdate: PropTypes.string,
  enddate: PropTypes.string,
  eventaddress: PropTypes.string,
  fetchCenter: PropTypes.func,
  setCorrectEventInfo: PropTypes.func,
  eventcity: PropTypes.string,
  eventstate: PropTypes.string,
  eventzipcode: PropTypes.string,
  eventcountry: PropTypes.string,
  usbcmemberid: PropTypes.string,
  eventInfoIsCorrect: PropTypes.bool,
  change: PropTypes.func,
  season: PropTypes.string,
  norecordsfound: PropTypes.bool,
  searchMode: PropTypes.bool,
  centers: PropTypes.object,
  memberidsuffix: PropTypes.string,
  memberidprefix: PropTypes.string,
  directorname: PropTypes.string,
  eventemail: PropTypes.string,
  directorssoemail: PropTypes.string,
  directorphone: PropTypes.string,
  directorcountry: PropTypes.string,
  directoraddress1: PropTypes.string,
  directoraddress2: PropTypes.string,
  directorcity: PropTypes.string,
  directorstate: PropTypes.string,
  directorzipcode: PropTypes.string,
  seasons: PropTypes.array,
  savingData: PropTypes.bool,
  isEventInfoVerified: PropTypes.bool,
  eventVerificationEmailSent: PropTypes.bool,
  resendingemail: PropTypes.bool,
  info: PropTypes.object,
  prestineinfo: PropTypes.object,
  oidc: PropTypes.object,
  user: PropTypes.object
}
function validate(values) {
  const errors = {}
  const { eventSeasonSettings } = values

  if (!isEmpty(eventSeasonSettings)) {
    const { firstSemesterStartDate, maxEventDuration, rollOverDate } = eventSeasonSettings

    if (!values.eventname) {
      errors.eventname = 'Required'
    }
    if (!values.startdate) {
      errors.startdate = 'Required'
    }
    else if (moment(values.startdate, "MM-DD-YYYY") < moment("MM-DD-YYYY")) {
      errors.startdate = 'Event start date cannot be in the past'
    }
    else if (moment(values.startdate, "MM-DD-YYYY") < moment(firstSemesterStartDate)) {
      errors.startdate = `The season start date is ${moment(firstSemesterStartDate).format('LL')}`
    }
    else if (moment(values.startdate, "MM-DD-YYYY") > moment(rollOverDate)) {
      errors.startdate = `Date can't be later than the season roll over date of ${moment(rollOverDate).format('LL')}`
    }
    else if (values.enddate && moment(values.startdate) > moment(values.enddate)) {
      errors.startdate = "Event start date cannot be later than the end date"
    }

    if (!values.enddate) {
      errors.enddate = 'Required'
    } else if (values.startdate && moment(values.enddate).diff(moment(values.startdate), 'days') < 0) {
      errors.enddate = "Event end date cannot be earlier than the start date"
      errors.startdate = ''
    } else if (moment(values.startdate).add(maxEventDuration - 1, 'day') < moment(values.enddate)) {
      errors.enddate = "Please correct dates. Event appears to be too long."
    }

    if (!values.centername) {
      errors.centername = 'Required'
    }
    if (!values.eventaddress) {
      errors.eventaddress = 'Required'
    }
    if (!values.eventcity) {
      errors.eventcity = 'Required'
    }
    if (!values.memberidprefix) {
      errors.memberidprefix = 'Required'
    }
    if (!values.directorname) {
      errors.directorname = 'Required'
    }
    if (!values.memberidsuffix) {
      errors.memberidsuffix = 'Required'
    }

    if (!values.eventemail) {
      errors.eventemail = 'Required'
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.eventemail)) {
      errors.directoremail = 'Invalid email address'
    }
  }
  //console.log('Event info errors', errors)
  return errors
}

function mapStateToProps(state, ownProps) {

  const formName = ownProps.form
  const selector = formValueSelector(formName)
  const eventId = selector(state, 'eventId')
  const centercertnumber = selector(state, 'centercertnumber')
  const centername = selector(state, 'centername')
  const eventname = selector(state, 'eventname')
  const eventaddress = selector(state, EventInfoFields.EVENT_ADDRESS)
  const eventcity = selector(state, EventInfoFields.EVENT_CITY)
  const eventstate = selector(state, EventInfoFields.EVENT_STATE)
  const eventzipcode = selector(state, EventInfoFields.EVENT_ZIPCODE)
  const eventcountry = selector(state, 'eventcountry')
  const usbcmemberid = selector(state, 'usbcmemberid')
  const eventInfoIsCorrect = selector(state, 'eventInfoIsCorrect')
  const season = selector(state, 'eventseason')
  const startdate = selector(state, 'startdate')
  const enddate = selector(state, 'enddate')
  const norecordsfound = selector(state, 'norecordsfound')
  const searchMode = selector(state, 'searchMode')
  const centers = selector(state, 'centers')
  const memberidprefix = selector(state, EventInfoFields.MEMBERID_PREFIX)
  const memberidsuffix = selector(state, EventInfoFields.MEMBERID_SUFFIX)
  const directorname = selector(state, EventInfoFields.DIRECTOR_NAME)
  const eventemail = selector(state, EventInfoFields.EVENT_EMAIL)
  const directorssoemail = selector(state, EventInfoFields.DIRECTOR_SSOEMAIL)
  const directorphone = selector(state, EventInfoFields.DIRECTOR_PHONE)
  const directorcountry = selector(state, EventInfoFields.DIRECTOR_COUNTRY)
  const directoraddress1 = selector(state, EventInfoFields.DIRECTOR_ADDRESS1)
  const directoraddress2 = selector(state, EventInfoFields.DIRECTOR_ADDRESS2)
  const directorcity = selector(state, EventInfoFields.DIRECTOR_CITY)
  const directorstate = selector(state, EventInfoFields.DIRECTOR_STATE)
  const directorzipcode = selector(state, EventInfoFields.DIRECTOR_ZIPCODE)
  const seasons = selector(state, 'seasons')
  const anyTouched = selector(state, 'anyTouched')
  const savingData = selector(state, 'savingData')
  const resendingemail = selector(state, 'resendingemail')
  const isEventInfoVerified = selector(state, EventInfoFields.IS_EVENT_INFO_VERIFIED)
  const eventVerificationEmailSent = selector(state, EventInfoFields.EVENT_VERIFICATION_EMAIL_SENT)
  const info = selector(state, 'info')
  const prestineinfo = selector(state, 'prestineinfo')

  return {
    eventId,
    eventname,
    anyTouched,
    centercertnumber,
    centername,
    startdate,
    enddate,
    eventaddress,
    eventcountry,
    eventcity,
    eventstate,
    eventzipcode,
    usbcmemberid,
    eventInfoIsCorrect,
    season,
    norecordsfound,
    searchMode,
    centers,
    memberidprefix,
    memberidsuffix,
    directorname,
    eventemail,
    directorssoemail,
    directorphone,
    directorcountry,
    directoraddress1,
    directoraddress2,
    directorcity,
    directorstate,
    directorzipcode,
    seasons,
    savingData,
    isEventInfoVerified,
    eventVerificationEmailSent,
    resendingemail,
    info,
    prestineinfo,
    oidc: state.oidc,
    user: state.user
  }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEvent,
    fetchCenter,
    fetchMember,
    fetchActiveSeasons,
    saveEventInfo,
    resendEventEmail,
    resendingEventEmail,
    setCorrectEventInfo
  }, dispatch)
}
export default reduxForm({
  validate,
  form: FormName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps, mapDispatchToProps)(EventInfo))



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventInfo/index.js